import { createAsyncThunk } from '@reduxjs/toolkit'
import { ProductService } from '../../api/ProductService'
import { IApi } from '../../interfaces/Api'
import { IProduct } from '../../interfaces/Product'

export const getProducts = createAsyncThunk('products/get', async(id: string) => {
    const api = new ProductService()
    const _products = await api.getProducts(id) 
    return _products as IApi<IProduct>
})